import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppState, PoliciesCodGuide } from '../../models/state';
import { ContextService } from '../../services/ctx.service';
import { NavService } from '../../services/nav.service';
import { StateService } from '../../services/state.service';
import { UtilsService } from '../../services/utils.service';
import { Router } from '@angular/router';
import { ApiHelperService } from '../../services/helpers/api-helper.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Input() set headerTitle(v: boolean) {
    if (v) this._headerTitle = v;
  }
  @Input() set showBackButton(v: boolean) {
    this._showBackButton = v;
  }

  links: { label: string; active: boolean; id: string; }[];
  subs: Subscription;
  state: Partial<AppState>;
  healthPolicies: PoliciesCodGuide[]
  policyHealthSelected: string;
  showPolicySelect = false;
  _showBackButton: boolean;
  _headerTitle: boolean;

  constructor(
    public ctx: ContextService,
    private nav: NavService,
    private stateService: StateService,
    private apiHelper: ApiHelperService
  ) {
    this._showBackButton = false;
    this.subs = new Subscription();
    this.state = this.stateService.getStateValue();
  }

  ngOnInit(): void {
    this.subs.add(
      this.stateService.getState().subscribe(state => {
        this.state = state;
        this.healthPolicies = state?.healthPolicies;
        this.policyHealthSelected = state.codGuia;
      }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onBack() {
    this.nav.back();
  }

  checkShowPolicySelect() {
    return this.healthPolicies?.length > 1 && this.nav.getLocationPath() === 'services';
  }

  async changeCodGuia(event) {
    await this.apiHelper.setSearchEngineList({ ...this.state, codGuia: event.value });
  }

}
